module.exports = __webpack_public_path__ + "img/lssjIcon.64dd01e2.png";